import {
  ListItem,
  ListItemText,
  SxProps,
  TypographyProps,
} from '@mui/material';
import { Theme } from '@mui/material/styles';
import * as React from 'react';

import { mergeSxProps } from '~/utils/helpers/sxProps';

import { useSxStyles } from './useStyles';

interface CustomSxStyles {
  listItemRoot: SxProps<Theme>;
  listItemTextMultiline: SxProps<Theme>;
  primaryText: SxProps<Theme>;
}

export interface Props {
  primaryText: string;
  secondaryText: string;
  primaryTypographyProps?: Partial<TypographyProps>;
  secondaryTypographyProps?: Partial<TypographyProps>;
  dataCy?: string;
  customSxStyles?: Partial<CustomSxStyles>;
}

export const InfoListItem: React.FC<Props> = (props) => {
  const {
    primaryText,
    secondaryText,
    primaryTypographyProps,
    secondaryTypographyProps,
    dataCy,
    customSxStyles,
  } = props;

  const baseStyles = useSxStyles();

  const sxStyles: CustomSxStyles = {
    listItemRoot: mergeSxProps(
      baseStyles.listItemRoot,
      customSxStyles?.listItemRoot,
    ),
    listItemTextMultiline: mergeSxProps(
      baseStyles.listItemTextMultiline,
      customSxStyles?.listItemTextMultiline,
    ),
    primaryText: mergeSxProps(
      baseStyles.primaryText,
      customSxStyles?.primaryText,
    ),
  };

  return (
    <ListItem disableGutters={true} sx={sxStyles.listItemRoot} data-cy={dataCy}>
      <ListItemText
        primary={primaryText}
        primaryTypographyProps={{
          variant: 'caption',
          color: 'textSecondary',
          ...primaryTypographyProps,
        }}
        secondary={secondaryText}
        // seems like a material-ui 4.9.10 issue, so we need cast
        secondaryTypographyProps={{
          variant: 'body2',
          color: 'textPrimary',
          component: 'span',
          ...secondaryTypographyProps,
        }}
        sx={mergeSxProps(sxStyles.listItemTextMultiline, sxStyles.primaryText)}
      />
    </ListItem>
  );
};
